import { SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { SettingsOutlineIcon } from "@dotnet/telematics-design-system";

import { MenuAnchorEl, useMediaQueries } from "../..";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../../../components/Button/Button";
import { useStyles } from "./styles";

interface ISettingsButtonProps {
  openMenu?: (e: { currentTarget: SetStateAction<MenuAnchorEl> }) => void;
  handleInitialView?: (value: boolean) => void;
}

const SettingsButton = ({
  openMenu,
  handleInitialView
}: ISettingsButtonProps) => {
  const { fromMd } = useMediaQueries();
  const { t } = useTranslation();

  const classes = useStyles();

  const buttonText = t("Button##settings");

  return (
    <>
      {fromMd && (
        <Button
          id="desktopSettingsButton"
          variant={BUTTON_VARIANTS.IconLeft}
          size={BUTTON_SIZES.Small}
          color={BUTTON_COLORS.White}
          icon={<SettingsOutlineIcon />}
          onClick={openMenu}
        >
          {buttonText}
        </Button>
      )}
      {handleInitialView && (
        <Button
          disableRipple
          fullWidth
          variant={BUTTON_VARIANTS.IconLeft}
          size={BUTTON_SIZES.Small}
          color={BUTTON_COLORS.White}
          icon={<SettingsOutlineIcon />}
          onClick={() => handleInitialView(false)}
          sx={classes.settingsButton}
        >
          {buttonText}
        </Button>
      )}
    </>
  );
};

export default SettingsButton;
